import { render } from "./InputSelectNewTheme.vue?vue&type=template&id=c1ae2f7c&scoped=true"
import script from "./InputSelectNewTheme.vue?vue&type=script&lang=js"
export * from "./InputSelectNewTheme.vue?vue&type=script&lang=js"

import "./InputSelectNewTheme.vue?vue&type=style&index=0&id=c1ae2f7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ae2f7c"]])

export default __exports__